import { render, staticRenderFns } from "./SelectMarkerForm.vue?vue&type=template&id=afa2a450&scoped=true&"
import script from "./SelectMarkerForm.vue?vue&type=script&lang=js&"
export * from "./SelectMarkerForm.vue?vue&type=script&lang=js&"
import style0 from "./SelectMarkerForm.vue?vue&type=style&index=0&id=afa2a450&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afa2a450",
  null
  
)

export default component.exports